// @flow

import React from 'react';
import Observer from 'react-intersection-observer';
import styled from 'styled-components';
import {
  numberRangeForStep,
  widthInUrl,
} from '../../helpers';
import ResponsiveImage from '../responsiveImage';
import type { Theme } from '../../types';

// 100 - 1200 in steps of 100
const imgSizes = numberRangeForStep(100, 1200, 100);
const largestImgSize = [...imgSizes].pop();

type Props = {|
  alt?: string,
  className?: string,
  url: string,
|};

const Image = styled<any, Theme>('img')`
  max-width: 100%;
`;

const PdbImage = ({
  alt,
  className,
  url,
}: Props) => {
  const srcSet = imgSizes.map(w => ({
    width: w,
    url: widthInUrl(url, w),
  }));

  const fixedWidth = !url.includes('__width__');

  if (fixedWidth) {
    return (
      <Observer rootMargin="0px 0px 150px 0px" triggerOnce>
        {({ inView, ref }) => (
          <div ref={ref}>
            {inView && (
              <Image
                alt={alt}
                className={className}
                src={url}
              />
            )}
          </div>
        )}
      </Observer>
    );
  }
  return (
    <ResponsiveImage
      alt={alt}
      className={className}
      src={widthInUrl(url, largestImgSize)}
      srcSet={srcSet}
    />
  );
};

PdbImage.defaultProps = {
  alt: '',
  className: '',
};

export default PdbImage;
